module.exports = __webpack_public_path__ + "46a78c4c.png";